import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getAllowedAttributes } from '../../props-filters';
import './Hamburger.scss';

var Hamburger = function (_PureComponent) {
  _inherits(Hamburger, _PureComponent);

  function Hamburger() {
    _classCallCheck(this, Hamburger);

    return _possibleConstructorReturn(this, (Hamburger.__proto__ || _Object$getPrototypeOf(Hamburger)).apply(this, arguments));
  }

  _createClass(Hamburger, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          onClick = _props.onClick,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['open', 'onClick', 'className']);

      return React.createElement(
        'div',
        _extends({
          className: cx({
            'sb-header-hamburger': true,
            'sb-header-hamburger--open': open
          }, className),
          onClick: onClick,
          'data-test-id': 'layout.hamburger'
        }, getAllowedAttributes(restProps)),
        React.createElement(
          'div',
          { className: 'sb-header-hamburger__container' },
          React.createElement('span', { className: 'sb-header-hamburger__bar' }),
          React.createElement('span', { className: 'sb-header-hamburger__bar' }),
          React.createElement('span', { className: 'sb-header-hamburger__bar' }),
          React.createElement('span', { className: 'sb-header-hamburger__bar' })
        )
      );
    }
  }]);

  return Hamburger;
}(PureComponent);

Hamburger.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default Hamburger;
//# sourceMappingURL=Hamburger.js.map